import React from 'react';
import cn from 'classnames';

import { useTheme } from 'providers/Theme.provider';
import { formatDayToYear, formatHourAndMinute } from 'utils/date/format.util';

import CN from './CashupTableRow.module.scss'; // common for deposit, cash and voucher tabs

const STYLE_PAID = Object.freeze({ textTransform: 'capitalize' });

const VoucherSoldItem = ({ amount, codeNumber, date, paid, purchasedBy, soldBy }) => {
  const { isDarkMode } = useTheme();

  const displayTime = formatHourAndMinute(date);
  const displayDate = formatDayToYear(date);

  return (
    <div
      data-bem="VoucherSoldItem"
      className={cn({
        [CN.tableRow]: true,
        [CN.medWidth]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <div className={CN.fixedColumnCell}>
        <span>{displayTime} </span>
        <span>{displayDate}</span>
      </div>

      <div className={CN.cell}>
        <span>{codeNumber}</span>
      </div>
      <div className={CN.cell}>
        <span>{purchasedBy}</span>
      </div>
      <div className={CN.cell}>
        <span>{soldBy}</span>
      </div>
      <div className={CN.cell}>
        <span>{amount}</span>
      </div>
      <div className={CN.cell}>
        <span style={STYLE_PAID}>{paid}</span>
      </div>
    </div>
  );
};
export default VoucherSoldItem;
